// 新闻管理
const evaluatingBanner = () => import('@/view/review-news/evaluating-banner'); // 评测轮播图
const evaluatingArticle = () => import('@/view/review-news/evaluating-article'); // 评测文章
const evaluatingArticleDetail = () => import('@/view/review-news/evaluating-article-detail'); // 评测文章详情
const evaluatingCategory = () => import('@/view/review-news/evaluating-category'); // 评测分类
const goodBanner = () => import('@/view/review-news/good-banner'); // 产品轮播图
const goodArticle = () => import('@/view/review-news/good-article'); // 产品文章
const goodArticleDetail = () => import('@/view/review-news/good-article-detail'); // 产品文章详情
const goodCategory = () => import('@/view/review-news/good-category'); // 产品分类
const brandBanner = () => import('@/view/review-news/brand-banner'); // 品牌轮播图
const brandArticle = () => import('@/view/review-news/brand-article'); // 品牌文章
const brandArticleDetail = () => import('@/view/review-news/brand-article-detail'); // 品牌文章详情
const brandCategory = () => import('@/view/review-news/brand-category'); // 品牌分类

export default [{
        path: '/evaluating-banner',
        name: 'evaluatingBanner',
        component: evaluatingBanner
    },
    {
        path: '/evaluating-article',
        name: 'evaluatingArticle',
        component: evaluatingArticle
    },
    {
        path: '/evaluating-article-detail',
        name: 'evaluatingArticleDetail',
        component: evaluatingArticleDetail
    },
    {
        path: '/evaluating-category',
        name: 'evaluatingCategory',
        component: evaluatingCategory
    },{
        path: '/good-banner',
        name: 'goodBanner',
        component: goodBanner
    },
    {
        path: '/good-article',
        name: 'goodArticle',
        component: goodArticle
    },
    {
        path: '/good-article-detail',
        name: 'goodArticleDetail',
        component: goodArticleDetail
    },
    {
        path: '/good-category',
        name: 'goodCategory',
        component: goodCategory
    },{
        path: '/brand-banner',
        name: 'brandBanner',
        component: brandBanner
    },
    {
        path: '/brand-article',
        name: 'brandArticle',
        component: brandArticle
    },
    {
        path: '/brand-article-detail',
        name: 'brandArticleDetail',
        component: brandArticleDetail
    },
    {
        path: '/brand-category',
        name: 'brandCategory',
        component: brandCategory
    }
];